import { CustomizationOption, ProductSizeOption, AddOnOption, SelectedCustomOption } from '../types';

export const DEFAULT_SIZES: ProductSizeOption[] = [
  { name: 'Regular', price: 0 },
  { name: 'Large', price: 5000 },
  { name: 'Hot', price: 0 },
];

export const DEFAULT_SIZE: ProductSizeOption = DEFAULT_SIZES[0];

export const DEFAULT_MASTER_TOPPINGS: CustomizationOption[] = [
  { id: 'top-no-topping', name: 'Tanpa Topping', price: 0, isActive: true, order: 1 },
  { id: 'top-boba', name: 'Grass Jelly / Boba', price: 4000, isActive: true, order: 2 },
  { id: 'top-espresso-shot', name: 'Extra Espresso Shot', price: 5000, isActive: true, order: 3 },
  { id: 'top-ice-cream', name: 'Vanilla Ice Cream Scoop', price: 6000, isActive: true, order: 4 },
];

export const DEFAULT_TOPPING: AddOnOption = {
  id: 'top-no-topping',
  name: 'Tanpa Topping',
  price: 0,
};

export const DEFAULT_MASTER_SYRUPS: CustomizationOption[] = [
  { id: 'syr-no-syrup', name: 'Normal (Standard Recipe)', price: 0, isActive: true, order: 1 },
  { id: 'syr-vanilla', name: 'Vanilla Syrup', price: 4000, isActive: true, order: 2 },
  { id: 'syr-caramel', name: 'Caramel Syrup', price: 4000, isActive: true, order: 3 },
  { id: 'syr-hazelnut', name: 'Hazelnut Syrup', price: 4000, isActive: true, order: 4 },
];

export const DEFAULT_SYRUP: AddOnOption = {
  id: 'syr-no-syrup',
  name: 'Normal (Standard Recipe)',
  price: 0,
};

export function generateCartItemId(
  productId: string,
  sizeName?: string,
  toppingName?: string,
  syrupName?: string,
  customOptions?: SelectedCustomOption[]
): string {
  const customStr = Array.isArray(customOptions)
    ? customOptions
        .map((o) => `${o.groupId || ''}:${o.optionId || o.optionName || ''}`)
        .sort()
        .join('|')
    : '';
  return `${productId}_${sizeName || ''}_${toppingName || ''}_${syrupName || ''}_${customStr}`;
}

export function calculateItemUnitPrice(
  basePrice: number,
  size?: ProductSizeOption | AddOnOption | null,
  topping?: AddOnOption | null,
  syrup?: AddOnOption | null,
  customOptions?: SelectedCustomOption[] | null,
  additionalAddons?: any[] | null
): number {
  let total = Math.max(0, Number(basePrice) || 0);

  if (size && typeof size.price !== 'undefined' && size.price !== null) {
    const p = Number(size.price);
    if (Number.isFinite(p) && p > 0) total += p;
  }

  if (topping && typeof topping.price !== 'undefined' && topping.price !== null) {
    const p = Number(topping.price);
    if (Number.isFinite(p) && p > 0) total += p;
  }

  if (syrup && typeof syrup.price !== 'undefined' && syrup.price !== null) {
    const p = Number(syrup.price);
    if (Number.isFinite(p) && p > 0) total += p;
  }

  if (Array.isArray(customOptions)) {
    customOptions.forEach((opt) => {
      if (opt && typeof opt.price !== 'undefined' && opt.price !== null) {
        const p = Number(opt.price);
        if (Number.isFinite(p) && p > 0) total += p;
      }
    });
  }

  if (Array.isArray(additionalAddons)) {
    additionalAddons.forEach((opt) => {
      if (opt && typeof opt.price !== 'undefined' && opt.price !== null) {
        const p = Number(opt.price);
        if (Number.isFinite(p) && p > 0) total += p;
      }
    });
  }

  return total;
}
